import { createContext, useContext, FC, useState, useEffect, ReactNode } from 'react';
import { IntlProvider } from 'react-intl';

import { importMessages, LocaleMessages, SupportedLocales } from 'helpers/languages/translations';

const MultiLanguagesContext = createContext<
    { setLocale: (e: SupportedLocales) => void; locale: SupportedLocales } | undefined
>(undefined);

const MultiLanguagesProvider: FC<{ children?: ReactNode }> = ({ children }) => {
    const [locale, setLocale] = useState<SupportedLocales>('en');
    const [messages, setMessages] = useState<LocaleMessages | null>(null);

    useEffect(() => {
        importMessages(locale).then(setMessages).catch(console.log);
    }, [locale]);

    const MainApp = () => {
        return <>{children}</>;
    };

    return (
        <MultiLanguagesContext.Provider value={{ locale, setLocale }}>
            {messages ? (
                <IntlProvider locale={locale} messages={messages}>
                    <MainApp />
                </IntlProvider>
            ) : null}
        </MultiLanguagesContext.Provider>
    );
};

const useMultiLanguagesHandler = () => {
    const context = useContext(MultiLanguagesContext);
    if (context === undefined) {
        throw new Error('useMultiLanguagesHandler must be used within a MultiLanguagesProvider');
    }

    return context;
};

export { useMultiLanguagesHandler };
export default MultiLanguagesProvider;
